import React, { createRef } from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'

function hexColorToRgba(hexColor, opacity) {
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

const bigCategory = ['鞋类', '服饰', '数码', '美妆', '箱包', '手表', '配饰'];

class PipelineDouble11Floor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabList: [],
      tabIndex: 0,
      floorList: [],
      navFixed: false,
      venue: utils.getQueryString('venue'),
      venueGoodsId: utils.getParams('venueGoodsId') || '',
      venueStyleId: utils.getParams('venueStyleId') || '',
      checkedNav: '',
      checkedIndex: 0,
      navFixed: false,
      tabExpand: false,
      hideMask: true,
      navList: [],
      navPosition: 0,
      disableRender: true
    };
    this.adSwiper = null;

    this.navigationContentHeight = 44; // 导航条的高度值
    this.debounceTimer = '';
    this.lastNavCompOffsetTop = 0;
    this.navPosition = 0;
    this.navigationTab = null;
    this.isAnchorInSwitchTab = false;
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll',(e)=>{
        this.handleBodyScroll();
      });
    }
  }

  componentDidMount() {
    this.getData()
    document.querySelector('.nav-mask') && document.querySelector('.nav-mask').addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false)
  }

  getData = () => {
    let { grains = [] } = this.props.config.containerConfig;
    let floorList = grains;

    const cateList = []
    floorList.map((item, index) => {
      const { selectRuleList = [] } = item;
      let cateIds = [];
      selectRuleList.forEach((value, key) => {
        cateIds.push(value.categoryId);
      });
      cateIds = cateIds.join(',');
      cateList.push({
        "key": String(index),
        "cate": cateIds
      })
    })

    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        cateList,
        scene: 'ACTIVITY_11_TAB_REC',
        from: window.location.href
      },
    }).then(res => {
      res = res.data
      const copyList = JSON.parse(JSON.stringify(floorList));
      if (res.status == 0) {
        const { orderCateList = [] } = res.data || {}
        // const orderCateList = ['2', '1', '0', '3', '4', '5', '6'];
        let mapIndex = 0
        orderCateList.forEach((key, tabKey) => {
          floorList.forEach((item, index) => {
            if (key == index) {
              for (let i = mapIndex; i < copyList.length; i++) {
                floorList[i] = copyList[+key]
                floorList[i]['tab_key'] = index;
                mapIndex = i + 1
                break
              }
            }
          })
        })

        const tabList = []
        floorList.forEach((item, floorIndex) => {
          // 指定会场置顶
          if (item.tabName == this.state.venue) {
            floorList.splice(floorIndex, 1);
            floorList.unshift(item);
          }
          item.showPage = 1;
          tabList.push(item.tabName);
        })

        this.state.venue && tabList.forEach((tabItem, tabIndex) => {
          // 指定会场置顶
          if (tabItem == this.state.venue) {
            tabList.splice(tabIndex, 1);
            tabList.unshift(tabItem);
          }
        });
        this.setState({
          tabList,
          floorList
        }, () => {
          floorList.forEach((floor, floorIndex) => {
            this.getGoodsList(floor.tab_key, floorIndex)
          })
          setTimeout(() => {
            const { ztAdList = [] } = this.props.config;
            if (Swiper && ztAdList.length > 0) {
              this.adSwiper = new Swiper('.zt-content', {
                autoplay: ztAdList.length > 1 ? { disableOnInteraction: false } : false,
                speed: 500,
                loop: ztAdList.length > 1 ? true : false,
              });
            }
          }, 1000);
        })
      }
    })
  }

  getGoodsList = async (floorTabKey, floorIndex) => {
    const squareStageType = window.squareStageType;
    const { floorList } = this.state
    const floor = floorList[floorIndex]
    let goods_type = 0;
    switch (squareStageType) {
      case "预售":
        goods_type = 1
        break;
      case "预热":
        goods_type = 2
        break;
      case "正式":
        goods_type = 3
        break;
      case "全部商品":
        goods_type = 0
        break;
      default:
        break;
    }
    let res = await axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list',
      method: 'get',
      withCredentials: true,
      params: {
        is_all: 1,
        list_type: 3,
        tab_key: floorTabKey,
        page_id: utils.getPageId()
      },
    })
    const { status, data } = res.data;
    if (status === 0) {
      let goodsList = data.goods_list || [];

      // 指定会场里的指定商品置顶显示
      if (this.state.venue && this.state.venue == floor.tabName && this.state.venueGoodsId) {
        goodsList.forEach((goodsItem, goodsIndex) => {
          if (this.state.venue && this.state.venueGoodsId == goodsItem.goodsId && (goodsItem.styleId && this.state.venueStyleId == goodsItem.styleId)) {
            goodsList.splice(goodsIndex, 1);
            goodsList.unshift(goodsItem)
          }
        }) 
      }

      // 插入广告
      const adList = floor.adList || []
      adList.forEach((ad) => {
        const { startTime, endTime, img, position } = ad
        let pos = +position.trim() - 1
        const now = new Date().getTime()
        if (startTime && endTime && img && pos >= 0 && now >= new Date(startTime).getTime() && now <= new Date(endTime).getTime()) {
          ad.type = 'ad'
          goodsList = goodsList.slice(0, pos).concat([ad]).concat(goodsList.slice(pos, goodsList.length))        
        }
      })

      const pageSize = Math.ceil((goodsList.length - 6) / 30) + 1;
      floor.pageSize = pageSize >= 4 ? 4 : pageSize;
      floor.goodsList = goodsList

      this.setState({
        floorList,
        disableRender: false
      });
    }
  }

  handleBodyScroll = () => {
    const floorTabList = window.document.querySelector('.floor-tab-list');
    if (!floorTabList) {
      return;
    }
    const tabBarHeight = floorTabList.clientHeight
    const navigationBarHeight = this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = window.document.querySelector('.navigation-container-static-wrap').offsetTop - this.props.navigationBarHeight;
    const navMarginTop = Number(this.props.config.baseConfig.moduleMarginTop); // 导航模块上边距
    const productComList = window.document.querySelectorAll('.floor-item') || [];
    let checkedNav = '', checkedIndex = 0;

    const distance = window.document.querySelector('.pipeline-double11-floor').clientHeight + navOffsetTop - window.document.querySelector('.more-item').clientHeight;
    const navFixed = scrollHeight - navOffsetTop >= navMarginTop && scrollHeight < (distance - 20)

    if (scrollHeight < (distance - 50)) {
      document.querySelector('.navigation-container-fixed-wrap').style.opacity = 1
    } else if (scrollHeight >= (distance - 50) && scrollHeight < (distance - 15)) {
      const opacity = scrollHeight < distance ? ((scrollHeight - (distance - 50)) / 20).toFixed(2) :1;
      console.log('1 - opacity', 1 - opacity)
      document.querySelector('.navigation-container-fixed-wrap').style.opacity = 1 - opacity
    } else {
      document.querySelector('.navigation-container-fixed-wrap').style.opacity = 0
    }

    for (let i = 0;i < productComList.length; i += 1) {
      if ((scrollHeight + this.navigationContentHeight + navigationBarHeight) > productComList[i].offsetTop) {
        checkedNav = productComList[i].getAttribute('id');
        checkedIndex = i;
      }
    }

    if (navFixed != this.state.navFixed) {
      this.setState({
        navFixed
      });
    }

    if (checkedNav != this.state.checkedNav) {
      this.setState({
        checkedNav
      });
    }

    const list = window.document.querySelectorAll('.floor-item') || [];
    const stopIndex =  list.length - 1;
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      if (item && scrollHeight >= item.offsetTop - tabBarHeight - this.props.navigationBarHeight) {
        if (i == list.length - 1 || scrollHeight < list[i + 1].offsetTop - tabBarHeight - this.props.navigationBarHeight) {
          const tabIndex =  i > stopIndex ? stopIndex : i
          if (tabIndex != this.state.tabIndex) {
            this.setState({
              tabIndex
            }, () => {
              if (navFixed) {
                const tabItemEls = window.document.querySelectorAll('.floor-tab-item')
                if (tabItemEls && tabItemEls[tabIndex]) {
                  tabItemEls[tabIndex].scrollIntoView()
                }  
              }
            })
          }
          break
        }
      }
    }

    // 对导航滚动防抖
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.updateNavPostion(checkedNav);
    }, 60);
  }

  render() {
    const { baseConfig, ztAdList = [], moreInfo = {} } = this.props.config;
    const { tabList, tabIndex, floorList, navFixed, disableRender } = this.state

    const moreFloorBg = moreInfo.bgImg;

    if (disableRender || tabList.length == 0) {
      return null
    }
    return (
      <div
        className="pipeline-double11-floor"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
        }}
      >
        {this.renderNavigation()}
        <div className="floor-list">
          {
            floorList.map((floor, floorIndex) => {
              const goodsList = floor.goodsList || []
              const goodsNumCell = goodsList.length >= 20 && floorIndex == 0 ? 1 : 1
              const totalCell = Math.ceil(goodsList.length / goodsNumCell)
              let goodsArr = []
              for (let i = 0; i < totalCell; i++) {
                const arr = []
                for (let j = 0; j < goodsNumCell; j++) {
                  const idx = i * goodsNumCell + j
                  if (idx < goodsList.length) {
                    arr.push(goodsList[idx])
                  }
                }
                if (arr.length == goodsNumCell) {
                  goodsArr.push(arr)
                }
              }

              if (bigCategory.indexOf(floor.tabName) >= 0) {
                if (floor.showPage <= 1) {
                  goodsArr = goodsArr.slice(0, 6);
                } else if (floor.showPage >= 2 && floor.showPage <= 4) {
                  goodsArr = goodsArr.slice(0, (floor.showPage - 1) * 30 + 6);
                } else {
                  goodsArr = goodsArr.slice(0, 96);
                } 
              } else {
                if (floor.showPage <= 1) {
                  goodsArr = goodsArr.slice(0, 3);
                } else if (floor.showPage >= 2 && floor.showPage <= 4) {
                  goodsArr = goodsArr.slice(0, (floor.showPage - 1) * 30 + 3);
                } else {
                  goodsArr = goodsArr.slice(0, 93);
                }
              }

              floor.goodsArr = goodsArr;

              let ztAdView = null
              if (floorIndex == 0 && ztAdList.length > 0) {
                ztAdView = (
                  <div
                    key={`zt-ad-${floorIndex}`} className="zt-ad"
                    onClick={() => {
                      if (!this.adSwiper) {
                        return
                      }
                      const ztIndex = this.adSwiper.realIndex
                      const ztAd = ztAdList[ztIndex]
                      if (ztAd) {
                        const options = {
                          sort: ztIndex
                        }
                        utils.jumpToUrl(this.props.routeParams,ztAd.link,ztAd.link,options,-1, this.props, false, {
                          ptiId: `lego-sales:middleBanner:${ztIndex}`,
                          ptiName: '楼层广告位',
                          bizExtra: {
                            model_block: 'floorAdvertising',
                            floor_name: floor.tabName
                          }
                        });
                      }
                    }}
                  >
                    <div className="zt-content swiper-container">
                      <div className="swiper-wrapper">
                        {
                          ztAdList.map((ztAd, ztIndex) => {
                            return (
                              <img
                                key={ztIndex}
                                alt=""
                                className="cont swiper-slide"
                                src={utils.formatImgUrl(ztAd.img, this.props.webpSupport)}
                              />
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                )
              }

              return (
                [
                  <div
                    id={floor.tabName}
                    className='floor-item normal'
                    key={`floor-item-${floorIndex}`}
                  >
                    <div className="floor-title" style={{backgroundImage: `url(${utils.formatImgUrl(floor.headerImg, this.props.webpSupport)})`, backgroundSize: "100% 100%"}}>
                      {floor.tabName}
                    </div>
                    {
                      (goodsArr.length > 0) &&
                      <div className={utils.isAndroid() ? "content android" : "content"} style={{backgroundImage: `url(${utils.formatImgUrl(floor.floorBgImg, this.props.webpSupport)})`, backgroundSize: "100% 100%", backgroundRepeat: "no-repeat", backgroundColor: floor.floorBgColor}}>
                        {
                          goodsArr.length > 0 &&
                          <div className={`goods-block goods-block-${floorIndex}`}>
                            <div className={`goods-list`}>
                              {
                                goodsArr.map((arr, arrIndex) => {
                                  return (
                                    <div key={arrIndex} className="goods-arr-item">
                                      {
                                        arr.map((item, index) => {
                                          if (item.type == 'ad') {
                                            return (
                                              <div
                                                className="goods-ad"
                                                key={`${arrIndex}-${index}`}
                                                onClick={() => {
                                                  const options = {
                                                    sort: arrIndex
                                                  }
                                                  utils.jumpToUrl(this.props.routeParams, item.link, item.link, options, -1, this.props, false, {
                                                    ptiId: `lego-sales:floor:${arrIndex}`,
                                                    ptiName: '楼层商品',
                                                    bizExtra: {
                                                      model_block: 'floorGoods',
                                                      floor_name: floor.tabName,
                                                      goods_href: item.link,
                                                      goods_id: item.goods_id,
                                                      style_id: item.style_id,
                                                      cate_id: item.cate_id,
                                                      goods_sku_id: item.sku_id || 0
                                                    }
                                                  });
                                                }}
                                              >
                                                <LazyLoadImage
                                                  width="100%"
                                                  threshold={500}
                                                  height="100%"
                                                  src={item.img}
                                                  effect="opacity"
                                                />
                                              </div>
                                            )
                                          }
                                          return (
                                            <div
                                              className="goods-item goods-item"
                                              key={`${arrIndex}-${index}`}
                                              onClick={() => {
                                                const options = {
                                                  sort: arrIndex
                                                }
                                                utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, -1, this.props, false, {
                                                  ptiId: `lego-sales:floor:${arrIndex}`,
                                                  ptiName: '楼层商品',
                                                  bizExtra: {
                                                    model_block: 'floorGoods',
                                                    floor_name: floor.tabName,
                                                    goods_href: item.href,
                                                    goods_id: item.goods_id,
                                                    style_id: item.style_id,
                                                    cate_id: item.cate_id,
                                                    goods_sku_id: item.sku_id || 0
                                                  }
                                                });
                                              }}
                                            >
                                              <div className="goods-img">
                                                <LazyLoadImage
                                                  width="100%"
                                                  threshold={500}
                                                  height="100%"
                                                  src={utils.formatImgUrl(item.pic, this.props.webpSupport)}
                                                  effect="opacity"
                                                />
                                              </div>
                                              <img src="https://static.shihuocdn.cn/admin/files/20221205/6dfc91e4f598d9249b33f5e60789de9f.png" alt="" className="top-tag" />
                                              <div className="name" style={{ WebkitBoxOrient: "vertical" }}>{item.title}</div>
                                              <div className="price">
                                                <span className="cur-price"><span>¥</span>{item.now_price}</span>
                                                <span className="origin-price">¥{item.avg_order_price_30}</span>
                                              </div>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  )
                                })
                              }
                            </div>
                            {/* 展开更多 */}
                            <div 
                              className="fold-btn"
                              style={{
                                color: baseConfig.moreTextColor
                              }}
                              onClick={() => {
                                let scrollTop = 0;
                                if (floor.showPage == 1) {
                                  // 记录当前滚动条位置，点收起按钮时，页面要回滚到该位置
                                  scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                                  floor.startScrollTop = scrollTop;
                                }
                                if (floor.showPage + 1 > floor.pageSize) {
                                  floor.showPage = 1;
                                  window.scrollTo(0, floor.startScrollTop);
                                } else {
                                  floor.showPage = floor.showPage + 1
                                }
                                this.setState({});
                                utils.uploadTrack(this.props, {}, {
                                  bizExtra: {
                                    model_block: 'expand',
                                    floor_name: floor.tabName
                                  }
                                });
                              }}
                            >
                              {floor.showPage >= floor.pageSize ? '收起' : '展开更多'}
                              {
                                floor.showPage >= floor.pageSize ? (
                                  <svg t="1666004348086" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1731" width="12" height="12">
                                    <path d="M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z" p-id="1732" fill={baseConfig.moreTextColor}></path>
                                  </svg>
                                ) : (
                                  <svg t="1665649025900" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1547" width="12" height="12">
                                    <path d="M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z" p-id="1548" fill={baseConfig.moreTextColor}></path>
                                  </svg>
                                )
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>,
                  ztAdView
                ]
              )
            })
          }
        </div>
        {
          moreInfo.moreList && moreInfo.moreList.length > 0 ?
            <div
              className={`more-item`}
              style={{
                background: `url(${utils.formatImgUrl(moreFloorBg, this.props.webpSupport)}) center no-repeat`
              }}
            >
              <div className="list">
                {
                  moreInfo.moreList.slice(0, 10).map((item, index) => {
                    return (
                      <div
                        className="item"
                        key={index}
                        style={{
                          background: `url(${utils.formatImgUrl(item.bgImg, this.props.webpSupport)}) center no-repeat`
                        }}
                        onClick={() => {
                          window.localStorage.setItem('last_click_tab_name', item.title)
                          const options = {
                            sort: index
                          }
                          utils.jumpToUrl(this.props.routeParams, item.link, item.link, options, -1, this.props, false, {
                            ptiId: `lego-sales:floor`,
                            ptiName: '其他分会场',
                            bizExtra: {
                              model_block: "otherVenue",
                              floor_name: item.title
                            }
                          });
                        }}
                      >
                        <div className="img">
                          <LazyLoadImage
                            width="100%"
                            threshold={500}
                            height="100%"
                            src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                            effect="opacity"
                          />
                        </div>
                        <div className="title">{item.title}</div>
                        <div className="sub-title">{item.subTitle}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          : 
          <div
            className={`more-item`}
            style={{
              background: moreFloorBg ? `url(${utils.formatImgUrl(moreFloorBg, this.props.webpSupport)}) center no-repeat` : '',
              height: !moreFloorBg && '0px',
              marginTop: !moreFloorBg && '0px',
            }}
          ></div>
        }
      </div>
    );
  }

  // 导航栏
  renderNavigation() {
    const { baseConfig, containerConfig } = this.props.config;
    const { grains = [] } = containerConfig;
    const { tabExpand, hideMask, navPosition } = this.state;
    const navList = grains.map(item => item.tabName);
    const hasMore = navList.length > 3;
    const navigationWrapperClass = 'floor-navigation';
    let maskClass = tabExpand ? "nav-mask show" : "nav-mask hide";
    if (hideMask) {
      maskClass += ' hide-mask'
    }
    return (
      <div className={navigationWrapperClass}>
        <div className={maskClass} onTouchEnd={this.expandClick}></div>
        <div 
          className="navigation-container-static-wrap"
          style={{
            paddingTop: `${baseConfig.moduleMarginTop}px`,
            backgroundColor: this.props.backgroundColor,
            visibility: this.state.navFixed ? 'hidden' : 'visible',
          }}
        >
          <div className={hasMore ? 'floor-tab-list navigation-container-static has-more' : 'floor-tab-list navigation-container-static not-more'}>
            {navList.map((item, index) => {
              return (
                <div
                  className={navList.length <= 4 ? "nav-item auto-width" : "nav-item fixed-width"}
                  key={index}
                  onClick={this.navClick.bind(this, item, index)}
                  style={{
                    color: this.state.checkedNav === item ? baseConfig.fontSelectedColor : baseConfig.fontColor,
                    fontFamily: this.state.checkedNav === item ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                    fontWeight: utils.isAndroid() ? (this.state.checkedNav === item ? '500' : 'normal') : 'normal'
                  }}
                >
                  {item}
                </div>
              )
            })}
          </div>
          {
            hasMore && (
              <div
                className="expand-bar" onClick={this.expandClick}
                style={{
                  top: `${Number(baseConfig.moduleMarginTop)}px`,
                  backgroundImage: `linear-gradient(to right, ${hexColorToRgba(this.props.backgroundColor, 0)} 0%, ${hexColorToRgba(this.props.backgroundColor, 1)} 30%, ${hexColorToRgba(this.props.backgroundColor, 1)} 100%)`
                }}
              >
                <svg className={`arrow ${tabExpand ? 'on' : ''}`} width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="https://www.w3.org/2000/svg">
                  <g id="lego_open" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="" transform="translate(2.500000, 5.000000)" fill={baseConfig.fontColor} fillRule="nonzero">
                      <path d="M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z" id="路径"></path>
                    </g>
                  </g>
                </svg>
              </div>
            )
          }
        </div>
        <div
          className="navigation-container-fixed-wrap"
          ref={(ref) => this.navigationTab = ref}
          style={{
            position: 'fixed',
            backgroundColor: this.props.backgroundColor,
            display: (this.state.navFixed || navPosition > 0) ? 'block' : 'none',
            top: this.props.navigationBarHeight
          }}
        >
          {tabExpand 
            && <p 
                className="all-classify" 
                style={{
                  color: baseConfig.fontColor,
                  fontFamily: 'PingFangSC-Regular'
                }}>
                  全部分类
                </p>
          }
          <div className={`navigation-container-fixed ${tabExpand ? 'expand ' : ''}${hasMore ? 'has-more' : 'not-more'}`}>
            {navList.map((item, index) => {
              return (
                // offset值为 导航栏高度（45）- 3，
                <AnchorLink
                  key={`anchorlink_${index}`}
                  offset={() => {
                    utils.uploadTrack(this.props, {
                      sort: index
                    }, {
                      ptiId: `lego-sales:tab:${index}`,
                      ptiName: '楼层Tab',
                      bizExtra: {
                        model_block: 'floorTab',
                        tab_name: item
                      }
                    })
                    return this.props.navigationBarHeight + this.navigationContentHeight - 3
                  }} 
                  href={`#${item}`}
                >
                  <div
                    className={navList.length <= 4 ? "nav-item auto-width" : "nav-item fixed-width"}
                    key={index}
                    onClick={() => {this.setState({tabExpand: false, hideMask: true})}}
                    style={{
                      color: this.state.checkedNav === item ? baseConfig.fontSelectedColor : baseConfig.fontColor,
                      fontFamily: this.state.checkedNav === item ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                      fontWeight: utils.isAndroid() ? (this.state.checkedNav === item ? '500' : 'normal') : 'normal'
                    }}
                  > 
                    {item}
                  </div>
                </AnchorLink>
              )
            })}
          </div>
          {
            hasMore && (
              <div
                className="expand-bar" onClick={this.expandClick}
                style={{
                  backgroundImage: `linear-gradient(to right, ${hexColorToRgba(this.props.backgroundColor, 0)} 0%, ${hexColorToRgba(this.props.backgroundColor, 1)} 30%, ${hexColorToRgba(this.props.backgroundColor, 1)} 100%)`
                }}
              >
                <svg className={`arrow ${tabExpand ? 'on' : ''}`} width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="https://www.w3.org/2000/svg">
                  <g id="lego_open" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="" transform="translate(2.500000, 5.000000)" fill={baseConfig.fontColor} fillRule="nonzero">
                      <path d="M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z" id="路径"></path>
                    </g>
                  </g>
                </svg>
              </div>
            )
          }
        </div>
      </div>
    )
  }

  navClick = (item, index) => {
    utils.uploadTrack(this.props, {
      sort: index
    }, {
      ptiId: `lego-sales:tab:${index}`,
      ptiName: '楼层Tab',
      bizExtra: {
        model_block: 'floorTab',
        tab_name: item
      }
    })
    // 导航跳转
    this.setState({
      checkedNav: item,
      tabExpand: false,
      hideMask: true
    });
    if (typeof window !== 'undefined') {
      // window.location.href = `#${item}`;
      // 使用replace代替href跳转，避免在history中留下记录
      window.location.replace(`#${item}`);
    }
    // 向下继续滚动this.navigationContentHeight - 3单位
    setTimeout(() => {
      const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop) - (this.navigationContentHeight - 3) - this.props.navigationBarHeight;
      window.scrollTo(0, scrollTop);
    }, 60);
  }

  expandClick = () => {
    const navMarginTop = Number(this.props.config.baseConfig.moduleMarginTop); // 导航模块上边距
    let offsetTop = 0;
    if (!this.isAnchorInSwitchTab) {
      offsetTop = window.document.querySelector('.navigation-container-static-wrap').offsetTop + navMarginTop;
    } else {
      const targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
      offsetTop = targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop + navMarginTop;
    }
    !this.state.navFixed && window.scrollTo(0, offsetTop);
    const tabExpand = !this.state.tabExpand
    this.setState({
      tabExpand,
      hideMask: false
    });
    setTimeout(() => {
      this.setState({
        hideMask: !tabExpand
      });
    }, 250)
  }

  updateNavPostion = (checkedNav) => {
    // 导航条切换选中后，调整当前导航到居中位置
    let navigationBar, checkedNavItem;

    navigationBar = document.querySelector('.navigation-container-fixed');
    checkedNavItem = document.querySelector(`.navigation-container-fixed a[href="#${checkedNav}"]`); // 当前选中的导航item

    if (!checkedNav || !checkedNavItem) {
      return;
    }

    const navWidth = navigationBar.offsetWidth; // 导航栏宽度
    const checkedItemOffsetLeft = checkedNavItem.offsetLeft; // 元素距离左边距离
    const checkedItemWidth = checkedNavItem.offsetWidth;
    // 需要滚动的距离
    const shouldUpdateScroll = checkedItemOffsetLeft - (navWidth / 2 - checkedItemWidth / 2) - 16;
    if (navigationBar.scrollWidth > navWidth) {
      // 如果导航条可以滚动，执行滚动操作
      navigationBar.scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
      // 顶部固定导航条也执行滚动操作
      document.querySelector('.navigation-container-static').scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
    }
  }
}

PipelineDouble11Floor.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineDouble11Floor };
export default PipelineDouble11Floor;



// WEBPACK FOOTER //
// ./components/pipeline-double11Floor/index.js